<router>
{
    name: 'Sales Tool Escalation Rules',
}
</router>
<template lang="pug">
v-container
    v-row
        v-col
            EscalationRules

    //- v-btn(primary, @click="$auth.logout('aad')") Sign out
</template>
<script>

import EscalationRules from '@/components/salestool/escalationrules.vue';
export default {
    meta: {
        role: 'satescalationrules'
    },
    components: {
        EscalationRules
    },
    data () {
        return {
        };
    },
    methods: {

    },
    computed: {

    },
    mounted () {

    }
};
</script>

<style scoped>
</style>
